<template>
    <div></div>
</template>
<script>
    export default {
        name: 'ProxyRouter',
        mounted() {
            let target = this.$route.params.target;
            let params = this.$route.params.data

            try {
                if (params)
                    params = JSON.parse(params)
            } catch(err) {
                console.warn("An error occurred while processing the proxy-router params...")
            }

            console.log(`fire in the hole! target:${target}, params: ${Object.keys(params)}`)

            this.$router.replace({name: target, params})
        }
    }
</script>